import React from 'react'
import Anime from 'react-anime'
import styled from 'styled-components'

const Header = styled.header`
  display: flex;
  width: 100%;
  overflow: hidden;
  height: 170px;
  color: white;
  background: ${props => props.theme.color};
  border-radius: 10px;
  margin-bottom: 2em;
  align-items: ${({bottom}) => (bottom ? 'flex-end' : 'center')};
  justify-content: center;
`

const Image = styled.img`
  margin-top: 10px;
  height: ${props => props.height};
`

const ImageHeader = ({src, bottom, height}) => (
  <Anime opacity={[0.9, 1]} scale={[1.03, 1]}>
    <div>
      <Header bottom={bottom}>
        <Image src={src} height={height || null} alt="" />
      </Header>
    </div>
  </Anime>
)

const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 3em;
`

const Title = styled.h1`
  margin-bottom: 0.4em;
`

export default ({title, phrase, image: {src, height}, bottom, children}) => (
  <header>
    <ImageHeader src={src} height={height} bottom={bottom} />
    <TitleWrapper>
      <Title>{title}</Title>
      <h2>{phrase}</h2>
    </TitleWrapper>
    <p>{children}</p>
  </header>
)



// WEBPACK FOOTER //
// ./src/components/header.js